import { Keyboard } from 'lucide-react';
import styles from './Footer.module.css';

interface Props {
  onShortcuts: () => void;
  className?: string;
}

export function Footer({ onShortcuts, className }: Props) {
  return (
    <footer className={[styles.footer, className].filter(Boolean).join(' ')}>
      <div className={styles.inner}>
        <span className={styles.brand}>
          The<span className={styles.accent}>Investment</span>Analyst
          <span className={styles.year}>· {new Date().getFullYear()}</span>
        </span>
        <div className={styles.actions}>
          <button type="button" className={styles.action} onClick={onShortcuts}>
            <Keyboard size={14} strokeWidth={1.5} />
            <span>Shortcuts</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
